import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  identifier: '',
  password: '',
  showPassword: false,
  error: '',
  submitting: false,
  lockUntil: null,
  tick: 0,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setIdentifier(state, action) {
      state.identifier = action.payload;
    },
    setPassword(state, action) {
      state.password = action.payload;
    },
    toggleShowPassword(state) {
      state.showPassword = !state.showPassword;
    },
    setShowPassword(state, action) {
      state.showPassword = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setSubmitting(state, action) {
      state.submitting = action.payload;
    },
    setLockUntil(state, action) {
      state.lockUntil = action.payload;
    },
    incrementTick(state) {
      state.tick += 1;
    },
    resetTick(state) {
      state.tick = 0;
    },
    resetLoginState(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setIdentifier,
  setPassword,
  toggleShowPassword,
  setShowPassword,
  setError,
  setSubmitting,
  setLockUntil,
  incrementTick,
  resetTick,
  resetLoginState,
} = loginSlice.actions;

export const selectLoginIdentifier = (state) => state.login.identifier;
export const selectLoginPassword = (state) => state.login.password;
export const selectLoginShowPassword = (state) => state.login.showPassword;
export const selectLoginError = (state) => state.login.error;
export const selectLoginSubmitting = (state) => state.login.submitting;
export const selectLoginLockUntil = (state) => state.login.lockUntil;
export const selectLoginTick = (state) => state.login.tick;

export default loginSlice.reducer;
